export const getHashValue = (hash, key) => {
  const matches = hash.match(new RegExp(`${key}=([^&]*)`));
  return matches ? matches[1] : null;
};

export const getQueryParameter = (parameter, url = window.location.href) => {
  const name = parameter.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const buildURL = (sitePath, locationObj = window.location) => {
  const { protocol, hostname, port } = locationObj;
  const portPath = (port === '') ? '' : `:${port}`;
  return `${protocol}//${hostname}${portPath}${sitePath}`;
};

export const extractInviteFromURL = (path = document.location.pathname) => {
  const pathParts = path.split('/').filter((part) => part !== '');
  if (pathParts.length < 2) return { action: 'not invite' };
  const inviteId = pathParts.pop();
  const action = pathParts.pop().toLowerCase();
  return { inviteId, action };
};
